// This file is the webpack entry point

// Import the main Sass file
import 'scss/common.scss';

// Here you can import your components, icons, etc.
// For example:
//
// import modal from 'components/Modal';
// import 'icons/home.svg';
//
// Webpack will automatically look for files relative to `assets/scripts/` and `assets/`.

// main.js
import * as test from './components/animation';
import * as media from './components/media';
import * as listeners from './components/listeners';
import * as Popper from '@popperjs/core';
import * as bootstrap from 'bootstrap';
import * as modeSwitcher from './components/modeswitcher';


media.initializeCarousels();
media.initializeVideo();


modeSwitcher.modeSwitcher();

document.addEventListener("DOMContentLoaded", function () {
  listeners.dropdownClassListener();
  listeners.menuBarListener();
  listeners.doorsAnimationListener();
  listeners.peopleGridOrderListener();
  listeners.prefooterTiltListener();
});
